<template>
  <section class="description description__wrapper">
    <h1 v-if="callToAction">{{ callToAction }}</h1>
    <article
      v-if="description"
      ref="description"
      :class="['description', 'description__content', {'hidden': showKeepReading}]"
      v-html="description"/>
    <div
      v-show="showKeepReading"
      :style="obscureStyles"
      class="description description__obscure" >
      <p @click="contentHidden = false">Keep reading<icon
        icon-name="chevron-down"
        view-box="0 0 16 16"/></p>
    </div>
  </section>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";
import { mapState } from "vuex";

const visibleDescriptionHeight = 250;

export default {
  name: "DescriptionSection",
  components: {
    Icon
  },
  props: {
    isMobileProp: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      descriptionHeight: "",
      contentHidden: true
    };
  },
  computed: {
    ...mapState("campaign", {
      callToAction: state => state.subTitle,
      description: state => state.contentIntroduction,
      formTopColor: state => state.campaignDesignColors.formBackgroundTop
    }),
    obscureStyles() {
      if (this.showKeepReading) {
        return {
          backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0), ${
            this.formTopColor
          } 90%)`
        };
      }
      return {};
    },
    isMobile() {
      return this.isMobileProp;
    },
    showKeepReading() {
      return (
        this.descriptionHeight > visibleDescriptionHeight &&
        this.isMobile &&
        this.contentHidden
      );
    }
  },
  mounted() {
    this.handleDescriptionResize();
    window.addEventListener("resize", this.handleDescriptionResize);
  },
  methods: {
    handleDescriptionResize() {
      if (this.$refs.description) {
        this.descriptionHeight = this.$refs.description.clientHeight;
      }
    }
  }
};
</script>

<style lang="scss">
.description {
  &__wrapper {
    position: relative;
  }
  &__content {
    position: relative;

    &.hidden {
      max-height: 300px;
      overflow: hidden;
    }
  }
  &__obscure {
    align-items: flex-end;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 200px;
    position: absolute;
    left: 0;
    width: 100%;

    p {
      align-items: center;
      cursor: pointer;
      display: flex;
      margin-right: 2rem;
    }
  }
  .icon {
    margin-left: calc(0.5rem - 2px);
  }
}
</style>
